import React from 'react';
import './foto.scss';
import Photka from './photo.jpg';
import Skype from './skype.png';
import Gmail from './gmail.png';
import Github from './github.png';
// import Discord from './discord.png';
import Telegram from './telegram.png';

const Photo = () => {
    return (
        <div>
            <div className='Photo'>
                <img src={Photka} alt='Mikhail' />
            </div>
            <div className='contacts'>
                <a href='skype:zmichgen?chat'>
                    <img src={Skype} alt='skype' />
                </a>
                <a href='mailto:zmichgen@gmail.com'>
                    <img src={Gmail} alt='gmail' />
                </a>
                <a href='https://github.com/zmichgen'>
                    <img src={Github} alt='github' />
                </a>
                {/* <a href=''>
          <img src={Discord} alt='discord' />
        </a> */}
                <a href='https://t.me/zmichgen'>
                    <img src={Telegram} alt='telegram' />
                </a>
            </div>
            <div className='phone'>
                <span>+ 375 (25) 762-76-60</span>
                <span> Life)</span>
            </div>
        </div>
    );
};

export default Photo;
